// extracted by mini-css-extract-plugin
export default {"RecipeLoadWrapper":"RecipeLoad_RecipeLoadWrapper__bBdmr"};